(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lookbook"] && !Shopify.designMode) return;
  try {
     
  class LmLookBook extends HTMLElement {
    constructor () {
      super()

      this.injectVendorScripts()
      this.querySelectorAll('.lumin-lookbook-point-list-item').forEach((elem) => {
        this.handleTooltip(elem)
      })
    } 
    
    async injectVendorScripts () {
      if (!window.FloatingUICore) {
        const script = document.createElement('script')
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/core@1.6.0')
        document.head.appendChild(script) 
      }
      if (!window.FloatingUIDOM) {
        await new Promise(r => setTimeout(r, 500))

        const script = document.createElement('script')
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/dom@1.6.1')
        document.head.appendChild(script)
      }
    }

    handleTooltip(elem) {
      const btn = elem.querySelector('button')
      const tooltip = elem.querySelector('.lm-tooltip')

      function update() {
        window.FloatingUIDOM.computePosition(btn, tooltip, {
          middleware: [
            window.FloatingUIDOM.offset(0),
            window.FloatingUIDOM.autoPlacement()
          ],
        }).then(({x, y}) => {
          Object.assign(tooltip.style, {
            left: `${x}px`,
            top: `${y}px`,
          })
        })
      }

      function showTooltip() {
        tooltip.classList.add('show')
        update()
      }
      
      function hideTooltip() {
        tooltip.classList.remove('show')
        tooltip.classList.add('hiding')
        setTimeout(() => {
          tooltip.classList.remove('hiding')
        }, 200);
      }
      
      if (window.matchMedia("(pointer: coarse)").matches) {
        [
          ['mouseenter', showTooltip],
          ['mouseleave', hideTooltip],
          ['focus', showTooltip],
          ['blur', hideTooltip],
        ].forEach(([event, listener]) => {
          btn.addEventListener(event, listener)
        })
      } else {
        [
          ['focus', showTooltip],
          ['blur', hideTooltip],
        ].forEach(([event, listener]) => {
          btn.addEventListener(event, listener)
        })
      }
    }
  }
  customElements.define('lumin-lookbook', LmLookBook)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-collection-slider"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('j4all-video-stories')) return;

  customElements.define('j4all-video-stories', class extends HTMLElement {
    connectedCallback() {
      this.initFrame = requestAnimationFrame(() => this.init());
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.initFrame);
      cancelAnimationFrame(this.dragFrame || 0);
      clearTimeout(this.moveTimer);
      clearTimeout(this.modalTimer);
      this.events?.abort();
      this.resizeObserver?.disconnect();
      this.visibilityObserver?.disconnect();
      this.warmObserver?.disconnect();
      this.modalObserver?.disconnect();
      this.querySelectorAll('video').forEach(video => video.pause());
      this.clearDesktopBuffers?.();
      if (this.modal?.hasAttribute('open')) this.modal.hide();
      this.modal?.remove();
      this.modal = null;
      this.started = false;
    }

    on(element, type, callback, options = {}) {
      element.addEventListener(type, callback, {
        ...options,
        signal: this.events.signal
      });
    }

    init() {
      if (this.started || !this.isConnected) return;

      this.viewport = this.querySelector('[data-viewport]');
      this.track = this.querySelector('[data-track]');
      if (!this.viewport || !this.track) return;

      this.started = true;
      this.events = new AbortController();
      this.cards = Array.from(this.track.querySelectorAll(':scope > [data-card]'));
      this.count = this.cards.length;
      if (!this.count) return;

      this.cards.forEach((card, index) => {
        card.dataset.index = index;
      });

      this.autoplay = this.dataset.autoplay === 'true';
      this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.desktopQuery = matchMedia('(min-width: 750px)');
      this.muted = true;
      this.visible = false;
      this.nearViewport = false;
      this.userPaused = false;
      this.editorHold = false;
      this.activeLogical = 0;
      this.activeCard = this.cards[0];
      this.busy = false;
      this.drag = null;
      this.trackOffset = 0;
      this.moveDelta = 0;
      this.pendingSheet = false;
      this.announce = false;
      this.previousCard = null;
      this.bufferCards = [];

      this.measureAndLayout(true);

      this.on(this, 'click', event => this.click(event));
      this.on(this.viewport, 'pointerdown', event => this.pointerDown(event));
      this.on(this.viewport, 'pointermove', event => this.pointerMove(event));
      this.on(this.viewport, 'pointerup', event => this.pointerEnd(event));
      this.on(this.viewport, 'pointercancel', event => this.pointerEnd(event, true));
      this.on(this.viewport, 'dragstart', event => event.preventDefault());

      this.on(this.viewport, 'keydown', event => {
        if (event.key === 'Escape') {
          this.setSheet(this.current(), false);
          return;
        }

        if (
          event.target !== this.viewport ||
          this.current()?.classList.contains('is-open')
        ) return;

        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          this.moveBy(event.key === 'ArrowRight' ? 1 : -1, true);
        }
      });

      this.on(this.track, 'transitionend', event => {
        if (
          event.target === this.track &&
          event.propertyName === 'transform'
        ) {
          this.finishMove();
        }
      });

      ['play', 'pause', 'volumechange', 'playing'].forEach(type => {
        this.on(this, type, event => {
          if (!(event.target instanceof HTMLVideoElement)) return;

          const video = event.target;
          const card = video.closest('[data-card]');

          if (type === 'playing') {
            // Desktop primes the immediate neighbours behind their posters.
            // Those muted warm-up plays must not be treated as an active slide.
            if (video.dataset.j4Priming === 'true') return;

            if (card !== this.current() || this.blocked()) {
              video.pause();
              return;
            }
            this.revealOnFirstFrame(video, card);
          }

          this.sync(card);
        }, { capture: true });
      });

      this.on(this, 'ended', event => {
        if (!(event.target instanceof HTMLVideoElement)) return;
        if (
          event.target.closest('[data-card]') !== this.current() ||
          this.blocked()
        ) return;

        if (this.count > 1) {
          this.moveBy(1);
        } else if (this.autoplay && !this.reducedMotion) {
          this.resetVideo(event.target);
          this.playActive();
        }
      }, { capture: true });

      this.on(this, 'touchstart', event => {
        const sheet = event.target.closest('[data-sheet]');
        const touch = event.touches[0];

        this.sheetTouch = sheet && touch ? {
          card: sheet.closest('[data-card]'),
          x: touch.clientX,
          y: touch.clientY,
          top: sheet.querySelector('[data-products]').scrollTop
        } : null;
      }, { passive: true });

      this.on(this, 'touchmove', event => {
        const start = this.sheetTouch;
        const touch = event.touches[0];
        if (!start || !touch) return;

        const dy = touch.clientY - start.y;
        const dx = touch.clientX - start.x;

        if (!start.card.classList.contains('is-open')) {
          if (
            Number(start.card.dataset.productCount) > 1 &&
            dy < -35 &&
            -dy > Math.abs(dx)
          ) {
            if (event.cancelable) event.preventDefault();
            this.drag = null;
            this.setSheet(start.card, true);
            this.sheetTouch = null;
            this.ignoreClickUntil = Date.now() + 400;
          }
          return;
        }

        if (
          start.top <= 0 &&
          dy > 40 &&
          dy > Math.abs(dx)
        ) {
          if (event.cancelable) event.preventDefault();
          this.setSheet(start.card, false);
          this.sheetTouch = null;
          this.ignoreClickUntil = Date.now() + 400;
        }
      }, { passive: false });

      this.on(this, 'touchend', () => {
        this.sheetTouch = null;
      }, { passive: true });

      this.on(document, 'visibilitychange', () => {
        if (document.hidden) {
          this.pauseAll();
        } else {
          this.warmAround(this.activeLogical);
          this.playActive();
        }
      });

      this.on(document, 'shopify:block:select', event => {
        const card = event.target.closest('[data-card]');
        if (!card || !this.contains(card)) return;

        this.editorHold = true;
        this.pauseAll();
        this.activeLogical = Number(card.dataset.index);
        this.activeCard = card;
        this.measureAndLayout(true);
      });

      this.on(document, 'shopify:block:deselect', event => {
        if (!this.contains(event.target)) return;
        this.editorHold = false;
        this.playActive();
      });

      this.resizeObserver = new ResizeObserver(() => {
        const width = this.viewport.clientWidth;
        const gap = parseFloat(getComputedStyle(this).getPropertyValue('--j4-gap')) || 0;

        if (
          Math.abs(width - (this.lastWidth || 0)) > 1 ||
          Math.abs(gap - (this.gap || 0)) > 0.5
        ) {
          this.measureAndLayout(true);
        }
      });
      this.resizeObserver.observe(this.viewport);

      // Start buffering before the section is actually visible.
      this.warmObserver = new IntersectionObserver(entries => {
        this.nearViewport = entries[0].isIntersecting;
        if (this.nearViewport) this.warmAround(this.activeLogical);
      }, {
        rootMargin: '800px 0px 800px 0px',
        threshold: 0
      });
      this.warmObserver.observe(this);

      this.visibilityObserver = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;

        if (this.visible) {
          this.warmAround(this.activeLogical);
          this.playActive();
        } else {
          this.pauseAll();
        }
      }, { threshold: 0.15 });
      this.visibilityObserver.observe(this);
    }

    modulo(value, length = this.count) {
      return ((value % length) + length) % length;
    }

    current() {
      return this.activeCard;
    }

    video(card = this.current()) {
      return card?.querySelector('video') || null;
    }

    isDesktop() {
      return this.desktopQuery?.matches ?? window.innerWidth >= 750;
    }

    slotLimits() {
      const left = Math.floor((this.count - 1) / 2);
      return {
        min: -left,
        max: this.count - 1 - left
      };
    }

    slotForLogical(logical, active = this.activeLogical) {
      if (this.count <= 1) return 0;

      const { min, max } = this.slotLimits();
      let slot = logical - active;

      while (slot < min) slot += this.count;
      while (slot > max) slot -= this.count;

      return slot;
    }

    cardAtSlot(slot) {
      return this.cards.find(card => Number(card.dataset.slot) === slot) || null;
    }

    setCardSlot(card, slot) {
      if (!card) return;
      card.dataset.slot = String(slot);
      card.style.setProperty('--j4-card-x', `${slot * this.step}px`);
    }

    clearDesktopBuffers() {
      (this.bufferCards || []).forEach(card => card.remove());
      this.bufferCards = [];
    }

    makeDesktopBuffer(slot) {
      const logical = this.modulo(this.activeLogical + slot);
      const sourceCard = this.cards[logical];
      if (!sourceCard) return null;

      const clone = sourceCard.cloneNode(true);
      clone.dataset.buffer = 'true';
      clone.dataset.slot = String(slot);
      clone.classList.add('j4vs-buffer');
      clone.classList.remove('is-current', 'is-open', 'has-frame', 'is-playing', 'is-unmuted');
      clone.removeAttribute('aria-current');
      clone.setAttribute('aria-hidden', 'true');
      clone.inert = true;
      clone.style.setProperty('--j4-card-x', `${slot * this.step}px`);

      [clone, ...clone.querySelectorAll('*')].forEach(element => {
        element.removeAttribute('id');
        Array.from(element.attributes || []).forEach(attr => {
          if (attr.name.startsWith('data-shopify')) element.removeAttribute(attr.name);
        });
      });

      // Buffers are visual only. Keep the poster/product card, never duplicate video decoding.
      clone.querySelectorAll('video').forEach(video => video.remove());
      clone.querySelectorAll('.j4vs-controls').forEach(control => control.remove());
      clone.querySelectorAll('a,button,[tabindex]').forEach(element => {
        element.tabIndex = -1;
      });

      return clone;
    }

    buildDesktopBuffers() {
      this.clearDesktopBuffers();
      if (!this.isDesktop() || this.count <= 1 || !this.step) return;

      const { min, max } = this.slotLimits();
      const visibleReach = Math.ceil(
        (this.viewport.clientWidth / 2 + this.width / 2) / this.step
      );
      // One extra slot stays completely outside the viewport and makes the
      // normalization after a swipe invisible.
      const reach = Math.max(visibleReach + 1, Math.abs(min), Math.abs(max));

      for (let slot = -reach; slot < min; slot++) {
        const clone = this.makeDesktopBuffer(slot);
        if (clone) {
          this.track.appendChild(clone);
          this.bufferCards.push(clone);
        }
      }

      for (let slot = max + 1; slot <= reach; slot++) {
        const clone = this.makeDesktopBuffer(slot);
        if (clone) {
          this.track.appendChild(clone);
          this.bufferCards.push(clone);
        }
      }
    }

    measureAndLayout(jump = false) {
      clearTimeout(this.moveTimer);
      this.busy = false;
      this.drag = null;
      this.trackOffset = 0;
      this.moveDelta = 0;
      this.pendingSheet = false;
      this.previousCard = null;
      this.classList.remove('is-dragging');
      this.clearDesktopBuffers();

      this.width = this.cards[0].getBoundingClientRect().width;
      this.gap = parseFloat(getComputedStyle(this).getPropertyValue('--j4-gap')) || 0;
      this.step = this.width + this.gap;
      this.lastWidth = this.viewport.clientWidth;

      if (jump) this.classList.add('is-jumping');
      this.track.style.transform = 'translate3d(0,0,0)';

      this.cards.forEach((card, logical) => {
        this.setSheet(card, false, false);
        this.setCardSlot(card, this.slotForLogical(logical));
        card.classList.toggle('is-current', card === this.activeCard);

        if (card === this.activeCard) card.setAttribute('aria-current', 'true');
        else card.removeAttribute('aria-current');
      });

      this.buildDesktopBuffers();
      this.updateAccessibility(0);

      // Prime only current + immediate neighbours immediately. That keeps the
      // first swipe responsive without downloading the whole carousel at once.
      [-1, 0, 1].forEach(offset => {
        const index = this.modulo(this.activeLogical + offset);
        this.hydrateVideo(this.video(this.cards[index]), 'auto');
      });

      if (jump) {
        void this.track.offsetWidth;
        this.classList.remove('is-jumping');
      }

      this.playActive();
    }

    activateCard(card) {
      if (!card) return;

      this.activeCard = card;
      this.activeLogical = Number(card.dataset.index);

      this.cards.forEach(item => {
        const active = item === card;
        item.classList.toggle('is-current', active);
        if (active) item.setAttribute('aria-current', 'true');
        else item.removeAttribute('aria-current');
      });

      this.sync(card);
    }

    updateAccessibility(trackOffset = 0) {
      const center = this.viewport.clientWidth / 2;

      this.cards.forEach(card => {
        const slot = Number(card.dataset.slot) || 0;
        const cardCenter = center + slot * this.step + trackOffset;
        const left = cardCenter - this.width / 2;
        const right = cardCenter + this.width / 2;
        const outside = right <= 0 || left >= this.viewport.clientWidth;

        card.inert = outside;
        if (outside) card.setAttribute('aria-hidden', 'true');
        else card.removeAttribute('aria-hidden');
      });
    }

    setTrackOffset(px, immediate = false) {
      this.trackOffset = px;
      if (immediate) this.classList.add('is-dragging');
      this.track.style.transform = `translate3d(${px}px,0,0)`;
    }

    beginMove(delta, announce = false) {
      if (this.busy || !delta || this.count <= 1) return;

      delta = delta > 0 ? 1 : -1;
      const destination = this.cardAtSlot(delta);
      if (!destination) return;

      this.cards.forEach(card => this.setSheet(card, false, false));

      const previous = this.current();
      const previousVideo = this.video(previous);
      const destinationVideo = this.video(destination);

      this.userPaused = false;
      this.moveDelta = delta;
      this.announce = announce;
      this.busy = true;
      this.previousCard = previous;

      // The destination is always ready before the track begins settling.
      this.hydrateVideo(destinationVideo, 'auto');

      // A committed swipe changes the active state immediately. The old card
      // shrinks while the destination grows into the centre, matching the
      // natural carousel motion. Side-card clicks still do nothing on desktop.
      if (previousVideo && !previousVideo.paused) previousVideo.pause();
      this.activateCard(destination);
      this.startCard(destination, false);

      const target = -delta * this.step;
      this.classList.remove('is-dragging');

      // Continue from the finger's current transform to the snap point.
      void this.track.offsetWidth;
      this.setTrackOffset(target, false);
      this.updateAccessibility(target);

      clearTimeout(this.moveTimer);
      this.moveTimer = setTimeout(
        () => this.finishMove(),
        this.reducedMotion ? 0 : 500
      );
    }

    settleBack() {
      if (this.busy) return;

      this.busy = true;
      this.moveDelta = 0;
      this.classList.remove('is-dragging');
      void this.track.offsetWidth;
      this.setTrackOffset(0, false);

      clearTimeout(this.moveTimer);
      this.moveTimer = setTimeout(
        () => this.finishMove(),
        this.reducedMotion ? 0 : 500
      );
    }

    moveBy(delta, announce = false) {
      if (!delta) {
        this.settleBack();
        return;
      }
      this.beginMove(delta, announce);
    }

    finishMove() {
      if (!this.busy) return;
      clearTimeout(this.moveTimer);


      const delta = this.moveDelta || 0;
      this.classList.add('is-jumping');
      void this.track.offsetWidth;

      if (delta) {
        const { min, max } = this.slotLimits();

        this.cards.forEach(card => {
          let slot = Number(card.dataset.slot) - delta;
          if (slot < min) slot += this.count;
          if (slot > max) slot -= this.count;
          this.setCardSlot(card, slot);
        });
      }

      // Rebuild only the off-screen poster buffers while transitions are disabled.
      // The buffer that slid into view is replaced by the matching real card in
      // exactly the same visual position, so no new card pops in at the edge.
      this.buildDesktopBuffers();
      this.track.style.transform = 'translate3d(0,0,0)';
      this.trackOffset = 0;
      this.updateAccessibility(0);

      void this.track.offsetWidth;
      this.classList.remove('is-jumping');

      const departed = this.previousCard;
      this.previousCard = null;
      this.busy = false;
      this.moveDelta = 0;

      if (departed && departed !== this.current()) this.parkCard(departed);

      if (this.announce) {
        this.querySelector('[data-status]').textContent =
          `Video ${this.activeLogical + 1} van ${this.count}`;
      }

      this.warmAround(this.activeLogical);

      if (this.pendingSheet) {
        this.pendingSheet = false;
        this.setSheet(this.current(), true);
      } else {
        this.playActive();
      }
    }

    blocked() {
      return (
        !this.isConnected ||
        !this.visible ||
        document.hidden ||
        this.classList.contains('has-modal') ||
        this.current()?.classList.contains('is-open')
      );
    }

    pauseAll() {
      this.querySelectorAll('video').forEach(video => {
        if (!video.paused) video.pause();
      });
    }

    hydrateVideo(video, preload = 'metadata') {
      if (!video) return;

      if (preload === 'auto' || video.preload !== 'auto') {
        video.preload = preload;
      }

      const source = video.querySelector('source[data-src]');
      if (source && !source.getAttribute('src')) {
        source.setAttribute('src', source.dataset.src);
        video.load();
      }
    }

    warmAround(logical = this.activeLogical) {
      if (!this.count) return;

      [-2, -1, 0, 1, 2].forEach(offset => {
        const index = this.modulo(logical + offset);
        const card = this.cards[index];
        const video = this.video(card);
        if (!video) return;

        this.hydrateVideo(
          video,
          Math.abs(offset) <= 1 ? 'auto' : 'metadata'
        );
      });

    }

    primeDesktopNeighbours(logical = this.activeLogical) {
      // Intentionally no hidden autoplay. preload='auto' on the neighbours is
      // enough and avoids decoder contention during the first desktop swipe.
      if (!this.isDesktop() || !this.count) return;
      [-1, 1].forEach(offset => {
        const index = this.modulo(logical + offset);
        this.hydrateVideo(this.video(this.cards[index]), 'auto');
      });
    }

    resetVideo(video) {
      if (!video) return;

      const reset = () => {
        try { video.currentTime = 0; } catch (_) {}
      };

      if (video.readyState >= 1) reset();
      else video.addEventListener('loadedmetadata', reset, { once: true });
    }

    parkCard(card) {
      if (!card) return;

      const video = this.video(card);
      if (video) {
        video.pause();
        this.resetVideo(video);
      }

      card.classList.remove('has-frame', 'is-playing', 'is-unmuted');
      this.sync(card);
    }

    revealOnFirstFrame(video, card) {
      if (!video || !card) return;

      const reveal = () => {
        if (
          card === this.current() &&
          !card.classList.contains('is-open') &&
          !this.classList.contains('has-modal')
        ) {
          card.classList.add('has-frame');
        }
      };

      if ('requestVideoFrameCallback' in video) {
        video.requestVideoFrameCallback(reveal);
      } else {
        requestAnimationFrame(() => requestAnimationFrame(reveal));
      }
    }

    startCard(card, force = false) {
      if (!card || this.blocked()) return;
      if (
        !force &&
        (!this.autoplay || this.userPaused || this.editorHold || this.reducedMotion)
      ) return;

      const video = this.video(card);
      if (!video) return;

      this.hydrateVideo(video, 'auto');
      video.muted = this.muted;

      if (!video.paused && !video.ended) return;

      video.play().catch(() => {
        if (
          !force &&
          !video.muted &&
          card === this.current() &&
          !this.blocked()
        ) {
          this.muted = true;
          video.muted = true;
          video.play().catch(() => this.sync(card));
        }
        this.sync(card);
      });
    }

    playActive(force = false) {
      this.startCard(this.current(), force);
    }

    toggleMute(card) {
      if (card !== this.current() || this.blocked()) return;

      const video = this.video(card);
      if (!video) return;

      this.muted = !video.muted;
      video.muted = this.muted;

      if (video.paused && !this.userPaused) this.startCard(card, true);
      this.sync(card);
    }

    sync(card) {
      if (!card) return;

      const video = this.video(card);
      if (!video) return;

      card.classList.toggle('is-unmuted', !video.muted);
      card.classList.toggle('is-playing', !video.paused && !video.ended);

      card.querySelector('[data-mute]')?.setAttribute(
        'aria-label',
        video.muted ? 'Geluid aanzetten' : 'Geluid uitzetten'
      );

      card.querySelector('[data-play]')?.setAttribute(
        'aria-label',
        video.paused ? 'Video afspelen' : 'Video pauzeren'
      );
    }

    setSheet(card, open, resume = true) {
      if (!card?.querySelector('[data-sheet]')) return;
      if (open && Number(card.dataset.productCount) < 2) return;

      if (open && card !== this.current()) {
        const slot = Number(card.dataset.slot) || 0;
        this.pendingSheet = true;
        this.moveBy(slot === 0 ? 1 : Math.sign(slot));
        return;
      }

      const wasOpen = card.classList.contains('is-open');
      card.classList.toggle('is-open', open);

      const button = card.querySelector('[data-expand]');
      button?.setAttribute('aria-expanded', String(open));
      button?.setAttribute(
        'aria-label',
        open ? 'Productlijst sluiten' : 'Toon alle producten'
      );

      if (open) {
        card.querySelector('[data-products]').scrollTop = 0;
        this.pauseAll();
      } else if (wasOpen && resume) {
        if (card.contains(document.activeElement)) {
          button?.focus({ preventScroll: true });
        }
        this.playActive();
      }
    }

    click(event) {
      if (Date.now() < (this.ignoreClickUntil || 0)) {
        event.preventDefault();
        return;
      }

      if (event.target.closest('[data-prev]')) {
        this.moveBy(-1, true);
        return;
      }
      if (event.target.closest('[data-next]')) {
        this.moveBy(1, true);
        return;
      }

      const card = event.target.closest('[data-card]');
      if (!card) return;

      if (event.target.closest('[data-expand]')) {
        this.setSheet(card, !card.classList.contains('is-open'));
        return;
      }

      const buy = event.target.closest('[data-buy]');
      if (buy) {
        if (
          event.metaKey || event.ctrlKey || event.shiftKey || event.altKey
        ) return;

        if (!customElements.get('quick-add-modal')) return;
        const modal = this.getModal();
        if (!modal) return;

        event.preventDefault();
        this.classList.add('has-modal');
        this.pauseAll();
        modal.show(buy);

        clearTimeout(this.modalTimer);
        this.modalTimer = setTimeout(() => {
          if (!modal.hasAttribute('open')) {
            this.classList.remove('has-modal');
            this.playActive();
          }
        }, 10000);
        return;
      }

      if (event.target.closest('[data-mute]')) {
        this.toggleMute(card);
        return;
      }

      if (event.target.closest('[data-play]')) {
        const video = this.video(card);
        if (!video) return;

        if (video.paused) {
          this.userPaused = false;
          this.startCard(card, true);
        } else {
          this.userPaused = true;
          video.pause();
        }
        return;
      }

      if (
        !event.target.closest('a,button,[data-sheet]') &&
        event.target.closest('.j4vs-media')
      ) {
        if (card !== this.current()) {
          // Desktop is drag/arrow driven: clicking a side card must not
          // suddenly select it and pull it into the centre.
          if (this.isDesktop()) return;

          const slot = Number(card.dataset.slot) || 0;
          if (slot) this.moveBy(Math.sign(slot), true);
        } else {
          this.toggleMute(card);
        }
      }
    }

    getModal() {
      if (this.modal?.isConnected) return this.modal;

      const template = this.querySelector('[data-quick-template]');
      if (!template) return null;

      const fragment = document.importNode(template.content, true);
      this.modal = fragment.querySelector('quick-add-modal');
      document.body.appendChild(fragment);

      this.modalObserver = new MutationObserver(() => {
        const open = this.modal.hasAttribute('open');
        this.classList.toggle('has-modal', open);
        if (open) this.pauseAll();
        else this.playActive();
      });

      this.modalObserver.observe(this.modal, {
        attributes: true,
        attributeFilter: ['open']
      });

      return this.modal;
    }

    pointerDown(event) {
      if (
        event.button !== 0 ||
        this.busy ||
        event.target.closest('a,button')
      ) return;

      const card = event.target.closest('[data-card]');
      if (!card || card.classList.contains('is-open')) return;

      this.drag = {
        id: event.pointerId,
        x: event.clientX,
        y: event.clientY,
        offset: 0,
        time: performance.now(),
        card,
        sheet: !!event.target.closest('[data-sheet]'),
        axis: null
      };
    }

    pointerMove(event) {
      const drag = this.drag;
      if (!drag || drag.id !== event.pointerId) return;

      const dx = event.clientX - drag.x;
      const dy = event.clientY - drag.y;

      if (
        !drag.axis &&
        Math.max(Math.abs(dx), Math.abs(dy)) > 7
      ) {
        drag.axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';

        if (drag.axis === 'x') {
          this.viewport.setPointerCapture(event.pointerId);
          this.classList.add('is-dragging');
        }
      }

      if (drag.axis === 'y' && drag.sheet && dy < -35) {
        this.drag = null;
        this.ignoreClickUntil = Date.now() + 400;
        this.setSheet(drag.card, true);
        if (event.cancelable) event.preventDefault();
        return;
      }

      if (drag.axis !== 'x') return;
      if (event.cancelable) event.preventDefault();

      drag.offset = Math.max(-this.step, Math.min(this.step, dx));

      // Exactly one compositor transform write per animation frame.
      // No pausing, seeking, loading, DOM reordering or layout reads here.
      if (!this.dragFrame) {
        this.dragFrame = requestAnimationFrame(() => {
          this.dragFrame = 0;
          if (!this.drag || this.drag.axis !== 'x') return;
          this.setTrackOffset(this.drag.offset, true);
        });
      }
    }

    pointerEnd(event, cancelled = false) {
      const drag = this.drag;
      if (!drag || drag.id !== event.pointerId) return;

      this.drag = null;
      cancelAnimationFrame(this.dragFrame || 0);
      this.dragFrame = 0;

      if (drag.axis !== 'x') {
        this.classList.remove('is-dragging');
        return;
      }

      this.setTrackOffset(drag.offset, true);

      const dx = event.clientX - drag.x;
      const elapsed = Math.max(1, performance.now() - drag.time);
      const velocity = Math.abs(dx) / elapsed;

      const advance =
        !cancelled &&
        (
          Math.abs(dx) > this.width * 0.16 ||
          (Math.abs(dx) > 10 && velocity > 0.35)
        );

      const delta =
        advance && this.count > 1
          ? (dx < 0 ? 1 : -1)
          : 0;

      this.ignoreClickUntil = Date.now() + 400;

      if (delta) this.beginMove(delta, true);
      else this.settleBack();
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
